import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import BackgroundImage from '../../Assets/images/HeroBg.png';
import TextImage from '../../Assets/images/TextImage.png';
import BCI from '../../Assets/images/BrowsCategoryIcon.png';
import BDI from '../../Assets/images/BDI.png';
import BDisI from '../../Assets/images/BDisI.png';
import BSI from '../../Assets/images/BSI.png';
import TDI from '../../Assets/images/TDI.png';
import { FaSearch } from 'react-icons/fa';
import Sources from '../../Modals/FilterBrowses/Sources';
import Upazila from './../../Modals/FilterBrowses/Upazila';
import Districts from './../../Modals/FilterBrowses/Districts';
import Department from '../../Modals/FilterBrowses/Department';
import Categories from '../../Modals/FilterBrowses/Categories';
import MobileHeroImage from '../../Assets/images/HeroMobileBG.jpeg';
import ModalTabs from '../ModalTabs/ModalTabs';


const Hero = () => {
  const [isCategoryModalOpen, setIsCategoryModalOpen] = useState(false);
  const [isDepartmentModalOpen, setIsDepartmentModalOpen] = useState(false);
  const [isDistrictModalOpen, setIsDistrictModalOpen] = useState(false);
  const [isUpazilaModalOpen, setIsUpazilaModalOpen] = useState(false);
  const [isSourceModalOpen, setIsSourceModalOpen] = useState(false);
  const [isTenderDeadlineModalOpen, setIsTenderDeadlineModalOpen] = useState(false);
  const [activeTab, setActiveTab] = useState(null); // State to track active tab

  const navigate = useNavigate();
  const isMobile = window.innerWidth <= 440;
  const [searchInput, setSearchInput] = useState('');
  const [searchQuery, setSearchQuery] = useState('');

  const handleSearchClick = () => {
    navigate('/limitedTenderView', { state: { searchTerm: searchInput } });
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      handleSearchClick();
    }
  };

  const handleSearchChange = (e) => {
    const inputValue = e.target.value.toLowerCase();
    setSearchInput(inputValue);
    setSearchQuery(inputValue);
  };

  // Handlers for opening modals
  const handleModalOpen = (modalType) => {

    if (activeTab) {
      handleModalClose(activeTab);
    } 
    
    setActiveTab(modalType); // Set the active tab when a modal is opened
    switch (modalType) {
      case 'category_v':
        setIsCategoryModalOpen(true);
        break;
      case 'department_v':
        setIsDepartmentModalOpen(true);
        break;
      case 'district_v':
        setIsDistrictModalOpen(true);
        break;
      case 'upazila_v':
        setIsUpazilaModalOpen(true);
        break;
      case 'source_v':
        setIsSourceModalOpen(true);
        break;
      case 'tenderDeadline_v':
        setIsTenderDeadlineModalOpen(true);
        break;
      default:
        break;
    }
  };

  // Handlers for closing modals
  const handleModalClose = (modalType) => {
    setActiveTab(null); // Reset the active tab when a modal is closed
    switch (modalType) {
      case 'category_v':
        setIsCategoryModalOpen(false);
        break;
      case 'department_v':
        setIsDepartmentModalOpen(false);
        break;
      case 'district_v':
        setIsDistrictModalOpen(false);
        break;
      case 'upazila_v':
        setIsUpazilaModalOpen(false);
        break;
      case 'source_v':
        setIsSourceModalOpen(false);
        break;
      case 'tenderDeadline_v':
        setIsTenderDeadlineModalOpen(false);
        break;
      default:
        break;
    }
  };

  // Modal Component (inside Hero)
  const Modal = ({ onClose, children }) => (
    <div className="fixed inset-0 z-50 flex justify-center">
      {/* Background Overlay */}
      <div
        className="absolute inset-0 bg-black opacity-50"
        onClick={onClose}
      ></div>

      {/* Modal Content */}
      <div className="relative bg-BrowsBg shadow-lg md:p-2 p-2 md:w-11/12 w-full overflow-y-auto md:h-[580px] 2xl:h-[860px] md:top-10 2xl:top-16 rounded">
        {/* Close Button */}
        <button
          className="absolute top-4 right-4 text-black hover:text-red-500 text-xl font-bold"
          onClick={onClose}
        >
          &#x2715;
        </button>

        {/* Tabs Inside Modal */}
        <ModalTabs className="" activeTab={activeTab} onTabClick={handleModalOpen} />

        {/* Modal Content */}
        {children}
      </div>
    </div>
  );

  return (
    <div
      id="hero"
      className="w-full md:bg-center md:bg-cover relative bg-no-repeat h-[500px] 2xl:h-[600px] md:py-10 py-6 md:mt-10 mt-8 md:px-10 px-2"
      style={{
        backgroundImage: `url(${isMobile ? MobileHeroImage : BackgroundImage})`,
      }}
    >
      <div className="container mx-auto">
        {/* Section 1: Headline */}
        <div className="md:mt-24 mt-20 mb-4 md:px-20 px-10 md:mr-0 mr-20">
          <img src={TextImage} className="" alt="Headline Text" />
        </div>

        <div className="md:px-0 px-4 container mx-auto">
          <div className="bg-white md:shadow-lg shadow rounded-2xl p-4 2xl:p-10 mx-auto md:translate-y-1/4 2xl:translate-y-3/4 translate-y-1/5">
            {/* Section 2: Filter with Search */}
            <div className="flex justify-center mt-0">
              <div className="flex items-center bg-white rounded-lg shadow-md p-1 w-full border border-blue-600">
                <input
                  type="text"
                  placeholder="Search by keyword"
                  value={searchInput}
                  onKeyDown={handleKeyDown}
                  onChange={handleSearchChange}
                  className="flex-grow p-1 rounded-l-lg focus:outline-none focus:ring-0 border-none md:text-sm text-xs"
                />
                <button
                  onClick={() => handleSearchClick(searchInput)}
                  className="items-center bg-blue-600 text-white md:px-6 px-2 md:py-2 py-1 rounded-lg hover:bg-blue-700 md:-ml-0 -ml-20 md:flex hidden"
                >
                  <FaSearch className="mr-2" />
                  Search
                </button>
              </div>
            </div>

            {/* Section 3: Buttons */}
            <div className="flex flex-wrap justify-center gap-3 mt-3 text-xs 2xl:text-lg">
              {[
                {
                  label: 'Browse by Categories',
                  icon: BCI,
                  modal: 'category_v',
                },
                {
                  label: 'Browse by Departments',
                  icon: BDI,
                  modal: 'department_v',
                },
                {
                  label: 'Browse by District',
                  icon: BDisI,
                  modal: 'district_v',
                },
                { label: 'Browse by Upazila', icon: BDisI, modal: 'upazila_v' },
                { label: 'Browse by Source', icon: BSI, modal: 'source_v' },
              ].map(({ label, icon, modal }) => (
                <button
                  key={modal}
                  className="flex items-center gap-2 bg-modalBtnColor text-blue-500 md:px-4 2xl:px-8 px-4 py-2 rounded-md border border-gray-200 shadow hover:bg-blue-100 md:w-auto w-[260px]"
                  onClick={() => handleModalOpen(modal)}
                >
                  <img src={icon} alt={label} className="w-5 h-5" />
                  {label}
                </button>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Modals */}
      {isCategoryModalOpen && (
        <Modal onClose={() => handleModalClose('category_v')}>
          <Categories />
        </Modal>
      )}
      {isDepartmentModalOpen && (
        <Modal onClose={() => handleModalClose('department_v')}>
          <Department />
        </Modal>
      )}
      {isDistrictModalOpen && (
        <Modal onClose={() => handleModalClose('district_v')}>
          <Districts />
        </Modal>
      )}
      {isUpazilaModalOpen && (
        <Modal onClose={() => handleModalClose('upazila_v')}>
          <Upazila />
        </Modal>
      )}
      {isSourceModalOpen && (
        <Modal onClose={() => handleModalClose('source_v')}>
          <Sources />
        </Modal>
      )}
    </div>
  );
};

export default Hero;




// import React, { useState } from 'react';
// import { useNavigate } from 'react-router-dom';
// import BackgroundImage from '../../Assets/images/HeroBg.png';
// import TextImage from '../../Assets/images/TextImage.png';
// import BCI from '../../Assets/images/BrowsCategoryIcon.png';
// import BDI from '../../Assets/images/BDI.png';
// import BDisI from '../../Assets/images/BDisI.png';
// import BSI from '../../Assets/images/BSI.png';
// import TDI from '../../Assets/images/TDI.png';
// import { FaSearch } from 'react-icons/fa';
// import Sources from '../../Modals/FilterBrowses/Sources';
// import Upazila from './../../Modals/FilterBrowses/Upazila';
// import Districts from './../../Modals/FilterBrowses/Districts';
// import Department from '../../Modals/FilterBrowses/Department';
// import Categories from '../../Modals/FilterBrowses/Categories';
// import MobileHeroImage from '../../Assets/images/HeroMobileBG.jpeg';
// const Hero = () => {
//   const [isCategoryModalOpen, setIsCategoryModalOpen] = useState(false);
//   const [isDepartmentModalOpen, setIsDepartmentModalOpen] = useState(false);
//   const [isDistrictModalOpen, setIsDistrictModalOpen] = useState(false);
//   const [isUpazilaModalOpen, setIsUpazilaModalOpen] = useState(false);
//   const [isSourceModalOpen, setIsSourceModalOpen] = useState(false);
//   const [isTenderDeadlineModalOpen, setIsTenderDeadlineModalOpen] =
//     useState(false);

//   const navigate = useNavigate();
//   const isMobile = window.innerWidth <= 440;
//   const [searchInput, setSearchInput] = useState('');
//   const [searchQuery, setSearchQuery] = useState('');
//   const [activeTab, setActiveTab] = useState(null); // State to track active tab

//  const handleSearchClick = () => {
//    navigate('/limitedTenderView', { state: { searchTerm: searchInput } });
//   //  setSearchInput('');
//   };
  
//     const handleKeyDown = e => {
//       if (e.key === 'Enter') {
//         e.preventDefault();
//         handleSearchClick();
//       }
//     };

//   const handleSearchChange = e => {
//     const inputValue = e.target.value.toLowerCase();
//     setSearchInput(inputValue);
//     setSearchQuery(inputValue);
//   };

//   // Handlers for opening modals
//   const handleModalOpen = modalType => {
//     switch (modalType) {
//       case 'category_v':
//         setIsCategoryModalOpen(true);
//         break;
//       case 'department_v':
//         setIsDepartmentModalOpen(true);
//         break;
//       case 'district_v':
//         setIsDistrictModalOpen(true);
//         break;
//       case 'upazila_v':
//         setIsUpazilaModalOpen(true);
//         break;
//       case 'source_v':
//         setIsSourceModalOpen(true);
//         break;
//       case 'tenderDeadline_v':
//         setIsTenderDeadlineModalOpen(true);
//         break;
//       default:
//         break;
//     }
//   };

//   // Handlers for closing modals
//   const handleModalClose = modalType => {
//     switch (modalType) {
//       case 'category_v':
//         setIsCategoryModalOpen(false);
//         break;
//       case 'department_v':
//         setIsDepartmentModalOpen(false);
//         break;
//       case 'district_v':
//         setIsDistrictModalOpen(false);
//         break;
//       case 'upazila_v':
//         setIsUpazilaModalOpen(false);
//         break;
//       case 'source_v':
//         setIsSourceModalOpen(false);
//         break;
//       case 'tenderDeadline_v':
//         setIsTenderDeadlineModalOpen(false);
//         break;
//       default:
//         break;
//     }
//   };

//   return (
//     <div
//       id="hero"
//       className="w-full md:bg-center md:bg-cover relative bg-no-repeat h-[500px] 2xl:h-[600px] md:py-10 py-6 md:mt-10 mt-8 md:px-10 px-2"
//       // style={{ backgroundImage: `url(${BackgroundImage})` }}

//       style={{
//         backgroundImage: `url(${isMobile ? MobileHeroImage : BackgroundImage})`,
//       }}
//     >
//       <div className="container mx-auto ">
//         {/* Section 1: Headline */}
//         <div className="md:mt-24 mt-20 mb-4 md:px-20 px-10 md:mr-0 mr-20">
//           <img src={TextImage} className="" alt="Headline Text" />
//         </div>

//         <div className="md:px-0 px-4 container mx-auto">
//           <div className="bg-white md:shadow-lg shadow rounded-2xl p-4 2xl:p-10 mx-auto md:translate-y-1/4 2xl:translate-y-3/4 translate-y-1/5">
//             {/* Section 2: Filter with Search */}
//             <div className="flex justify-center mt-0">
//               <div className="flex items-center bg-white rounded-lg shadow-md p-1 w-full border border-blue-600">
//                 <input
//                   type="text"
//                   placeholder="Search by keyword"
//                   value={searchInput}
//                   onKeyDown={handleKeyDown}
//                   onChange={handleSearchChange}
//                   className="flex-grow p-1 rounded-l-lg focus:outline-none focus:ring-0 border-none md:text-sm text-xs"
//                 />
//                 <button
//                   onClick={() => handleSearchClick(searchInput)} // Pass searchInput as searchTerm
//                   className="items-center bg-blue-600 text-white md:px-6 px-2 md:py-2 py-1 rounded-lg hover:bg-blue-700 md:-ml-0 -ml-20 md:flex hidden"
//                 >
//                   <FaSearch className="mr-2" />
//                   Search
//                 </button>
//               </div>
//             </div>

//             {/* Section 3: Buttons */}
//             <div className="flex flex-wrap justify-center gap-3 mt-3 text-xs 2xl:text-lg ">
//               {[
//                 {
//                   label: 'Browse by Categories',
//                   icon: BCI,
//                   modal: 'category_v',
//                 },
//                 {
//                   label: 'Browse by Departments',
//                   icon: BDI,
//                   modal: 'department_v',
//                 },
//                 {
//                   label: 'Browse by District',
//                   icon: BDisI,
//                   modal: 'district_v',
//                 },
//                 { label: 'Browse by Upazila', icon: BDisI, modal: 'upazila_v' },
//                 { label: 'Browse by Source', icon: BSI, modal: 'source_v' },
//                 // { label: 'Browse by Advertisement', icon: BDisI, modal: '' },
//                 // { label: 'Browse by All e-GP', icon: BDisI, modal: '' },
//                 // {
//                 //   label: 'Tender Deadline',
//                 //   icon: TDI,
//                 //   modal: 'tenderDeadline_v',
//                 // },
//               ].map(({ label, icon, modal }) => (
//                 <button
//                   key={modal}
//                   className="flex items-center gap-2 bg-modalBtnColor text-blue-500 md:px-4 2xl:px-8 px-4 py-2 rounded-md border border-gray-200 shadow hover:bg-blue-100 md:w-auto w-[260px]"
//                   onClick={() => handleModalOpen(modal)}
//                 >
//                   <img src={icon} alt={label} className="w-5 h-5" />
//                   {label}
//                 </button>
//               ))}
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Modals */}
//       {isCategoryModalOpen && (
//         <Modal onClose={() => handleModalClose('category_v')}>
//           <Categories />
//         </Modal>
//       )}
//       {isDepartmentModalOpen && (
//         <Modal onClose={() => handleModalClose('department_v')}>
//           <Department />
//         </Modal>
//       )}
//       {isDistrictModalOpen && (
//         <Modal onClose={() => handleModalClose('district_v')}>
//           <Districts />
//         </Modal>
//       )}
//       {isUpazilaModalOpen && (
//         <Modal onClose={() => handleModalClose('upazila_v')}>
//           <Upazila />
//         </Modal>
//       )}
//       {isSourceModalOpen && (
//         <Modal onClose={() => handleModalClose('source_v')}>
//           <Sources />
//         </Modal>
//       )}
//       {/* {isTenderDeadlineModalOpen && (
//         <Modal onClose={() => handleModalClose('tenderDeadline_v')}>
//           <TenderDeadline />
//         </Modal>
//       )} */}
//     </div>
//   );
// };

// const Modal = ({ onClose, children }) => (
//   <div className="fixed inset-0 z-50 flex justify-center">
//     {/* Background Overlay */}
//     <div
//       className="absolute inset-0 bg-black opacity-50"
//       onClick={onClose}
//     ></div>

//     {/* Modal Content */}
//     <div className="relative bg-BrowsBg shadow-lg md:p-2 p-2 md:w-11/12 w-full overflow-y-auto md:h-[580px] 2xl:h-[860px] md:top-10 2xl:top-16 rounded">
//       {/* Close Button */}
//       <button
//         className="absolute top-4 right-4 text-black hover:text-red-500 text-xl font-bold"
//         onClick={onClose}
//       >
//         &#x2715;
//       </button>
//       {children}
//     </div>
//   </div>
// );

// export default Hero;